const HttpUtils = require('../../util/http_utils');
const StringUtils = require('../../util/string_utils').default;
const config = require('../../config');
const ErrorHandler = require('../error_handler/error_handler');

const eventList = {
    deivceRegister: 'device.register',
    deviceUnreg: 'device.unregister',
    deviceClearAll: 'device.clearAll'
};

const urls = {
    deviceList: '{0}userAccounts/{1}/devices',
    deviceRegister: '{0}userAccounts/{1}/devices',
    deviceUnregister: '{0}userAccounts/{1}/devices/{2}'
};

const deviceDefaults = {
    name: 'unknown',
    type: 'unknown',
    description: '',
    clientIdentifiers: {
        WMDRM: 'unknown'
    }
};

export default {

    init(playerConfig, eventEmitter) {
        this.playerConfig = playerConfig;
        this.baseUrl = config.esbUrl;
        this.authToken = 'Bearer ' + this.playerConfig.user.sessionToken;
        this.globalUserId = this.playerConfig.user.globalUserId;
        this.emitter = eventEmitter;
    },

    getAllRegisteredDevices() {
        const options = {
            uri: StringUtils.formatter(urls.deviceRegister, this.baseUrl, this.globalUserId),
            headers: {
                Authorization: this.authToken
            }
        };

        HttpUtils.get(options, this.requestHandler('get'));
    },

    register(deviceInfo) {
        const options = {
            uri: StringUtils.formatter(urls.deviceRegister, this.baseUrl, this.globalUserId),
            headers: {
                Authorization: this.authToken
            },
            body: Object.assign(deviceDefaults, deviceInfo)
        };

        HttpUtils.post(options, this.requestHandler('post'));
    },

    unregister(deviceID) {
        const options = {
            uri: StringUtils.formatter(urls.deviceUnregister, this.baseUrl, this.globalUserId, deviceID),
            headers: {
                Authorization: this.authToken
            }
        };

        HttpUtils.delete(options, this.requestHandler('delete'));
    },

    requestHandler(method) {
        let baseHandler = (success, body) => {
            if (success && body) {
                console.log(body);
                this.emitter.emit('deviceManagerSuccess', method, body);
            } else {
                this.emitter.emit('deviceManagerError', method, body);
            }
        };

        return {
            // TODO: Add some logic to the methods
            get(success, body) {
                baseHandler(success, body);
            },
            post(success, body) {
                baseHandler(success, body);
            },
            delete(success, body) {
                baseHandler(success, body);
            }
        }[method];
    },

    events() {}
};



// WEBPACK FOOTER //
// ./src/modules/device_manager/device_manager.js